import { UrlApi } from "../../../../../../services/apirest";

// Trae los datos actuales del cliente (misma ruta que usa EditarClientePedido).
export const getClientePorId = async (idCliente) => {
  const response = await fetch(UrlApi + `/envasado_clientes/xid/${idCliente}`);

  if (!response.ok) {
    throw new Error(`Error HTTP: ${response.status}`);
  }

  const rows = await response.json();
  return rows[0];
};
